import { Route, Routes } from 'react-router-dom';
import { LoginPage } from '../features/auth/LoginPage';
import { RegisterPage } from '../features/auth/RegisterPage';
import { AppLayout } from './AppLayout';
import { OnboardingPage } from '../features/orgs/OnboardingPage';
import { DashboardPage } from '../features/dashboard/DashboardPage';
import { ApiKeysPage } from '../features/apikeys/ApiKeysPage';
import { AuthenticationPage } from '../features/auth-config/AuthenticationPage';
import { WalletsPage } from '../features/wallets/WalletsPage';
import { WalletDetailPage } from '../features/wallets/WalletDetailPage';
import { RecoveryPage } from '../features/recovery/RecoveryPage';
import { AuditLogPage } from '../features/audit/AuditLogPage';
import { SettingsPage } from '../features/settings/SettingsPage';
import { NetworksPage } from '../features/settings/NetworksPage';
import { PoliciesLayout } from '../features/policies/PoliciesLayout';
import { PoliciesSessionsPage } from '../features/policies/PoliciesSessionsPage';
import { PoliciesRulesPage } from '../features/policies/PoliciesRulesPage';
import { PoliciesTokensPage } from '../features/policies/PoliciesTokensPage';

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />

      <Route element={<AppLayout />}>
        <Route path="/onboarding" element={<OnboardingPage />} />
        <Route index element={<DashboardPage />} />
        <Route path="api-keys" element={<ApiKeysPage />} />
        <Route path="authentication" element={<AuthenticationPage />} />
        <Route path="wallets" element={<WalletsPage />} />
        <Route path="wallets/:walletID" element={<WalletDetailPage />} />
        <Route path="networks" element={<NetworksPage />} />
        <Route path="recovery" element={<RecoveryPage />} />
        <Route path="policies" element={<PoliciesLayout />}>
          <Route index element={<PoliciesSessionsPage />} />
          <Route path="rules" element={<PoliciesRulesPage />} />
          <Route path="tokens" element={<PoliciesTokensPage />} />
        </Route>
        {/* Back-compat: keep /agents as a redirect for bookmarks. */}
        <Route path="agents" element={<PoliciesLayout />}>
          <Route index element={<PoliciesSessionsPage />} />
          <Route path="rules" element={<PoliciesRulesPage />} />
          <Route path="tokens" element={<PoliciesTokensPage />} />
        </Route>
        <Route path="audit" element={<AuditLogPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
    </Routes>
  );
}
